import {
  ADD_TO_BACKLOG_REQUEST,
  ADD_TO_BACKLOG_SUCCESS,
  ADD_TO_BACKLOG_FAILURE,
  LIST_BACKLOG_REQUEST,
  LIST_BACKLOG_SUCCESS,
  LIST_BACKLOG_FAILURE,
  MARK_AS_POSTED_REQUEST,
  MARK_AS_POSTED_SUCCESS,
  MARK_AS_POSTED_FAILURE,
  RESET_BACKLOG_ADD_STATE,
} from "../actions/contentBacklogActions";

const initialState = {
  // Add-to-backlog form status
  addStatus:  "idle",  // idle | submitting | success | error
  addError:   null,
  lastAdded:  null,    // { backlogId, topic } from most recent successful add

  // Queue list
  items:        [],
  listLoading:  false,
  listError:    null,

  // Mark-as-posted
  postingId:    null,  // backlogId currently being marked posted
  postError:    null,
};

const contentBacklogReducer = (state = initialState, action) => {
  switch (action.type) {

    // ── Add to backlog ───────────────────────────────────────────────────────
    case ADD_TO_BACKLOG_REQUEST:
      return { ...state, addStatus: "submitting", addError: null };

    case ADD_TO_BACKLOG_SUCCESS:
      return {
        ...state,
        addStatus: "success",
        addError:  null,
        lastAdded: action.payload,
        // Optimistically prepend the new item to the list so it appears immediately
        items: [
          {
            backlogId:        action.payload.backlogId,
            topic:            action.payload.topic || "",
            status:           "QUEUED",
            createdAt:        new Date().toISOString(),
          },
          ...state.items,
        ],
      };

    case ADD_TO_BACKLOG_FAILURE:
      return { ...state, addStatus: "error", addError: action.error };

    case RESET_BACKLOG_ADD_STATE:
      return { ...state, addStatus: "idle", addError: null, lastAdded: null };

    // ── List backlog ─────────────────────────────────────────────────────────
    case LIST_BACKLOG_REQUEST:
      return { ...state, listLoading: true, listError: null };

    case LIST_BACKLOG_SUCCESS:
      return { ...state, listLoading: false, items: action.payload || [], listError: null };

    case LIST_BACKLOG_FAILURE:
      return { ...state, listLoading: false, listError: action.error };

    // ── Mark as posted ───────────────────────────────────────────────────────
    case MARK_AS_POSTED_REQUEST:
      return { ...state, postingId: action.payload.backlogId, postError: null };

    case MARK_AS_POSTED_SUCCESS: {
      const { backlogId, postedAt } = action.payload;
      return {
        ...state,
        postingId: null,
        postError: null,
        items: state.items.map((item) =>
          item.backlogId === backlogId
            ? { ...item, status: "POSTED", postedAt }
            : item
        ),
      };
    }

    case MARK_AS_POSTED_FAILURE:
      return { ...state, postingId: null, postError: action.error };

    default:
      return state;
  }
};

export default contentBacklogReducer;
